import { map } from 'lodash';
import { Sort } from '../../NewStrategy/Sort';

const SortHeader = ({
  className = 'flex top-0',
  columns,
  width,
  type,
  handleSort,
}: {
  className?: string;
  columns: string[];
  width: number;
  type: string;
  handleSort: (type: string, direction: 'sortDown' | 'sortUp') => void;
}) => {
  return (
    <div className={`${className}`}>
      {map(columns, function renderColumn(columnName, i) {
        return (
          <div
            key={columnName + i}
            className={`
              flex
              w-full
              h-10
              items-center
              ${!i && 'sticky left-0'}
              ${
                width === 2 &&
                i === 0 &&
                'border-r border-grey-10 dark:border-grey-80'
              }
              border-b
              border-grey-10
              dark:border-grey-80
            `}
          >
            <div
              className={`
                flex
                items-center
                w-full
                h-full
              `}
            >
              <div className={`${i === 0 && 'ml-5'}`}>
                <Sort
                  columnName={columnName}
                  handleSort={handleSort}
                  type={type}
                  className="flex items-center"
                  columnClassName="font-medium text-xs cursor-pointer"
                />
              </div>
            </div>
          </div>
        );
      })}

      <div
        className={`
          flex
          w-full
          h-full
          pl-5
          col-span-2
          border-b
          border-grey-10
          dark:border-grey-80
          items-center
          uppercase
          font-medium
          text-xs
        `}
      >
        progress
      </div>
    </div>
  );
};

export default SortHeader;
